import React from 'react';
import styled from 'styled-components';

import { AppBar, Toolbar } from '@material-ui/core';

const AppBarRoot = styled(AppBar)`
	background-color: ${(props) => props.theme.palette.blocks.stickyAppBar.background};
	color: ${(props) => props.theme.palette.blocks.stickyAppBar.color};
	border-radius: 5px;

	.MuiToolbar-root {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.actions {
		.MuiButtonBase-root {
			img {
				width: 25px;
				height: 25px;
			}
		}
	}
`;

const StickyAppBar = ({ children, hide }) => (
	<AppBarRoot position="sticky" style={{ display: hide ? 'none' : '' }}>
		<Toolbar>{children}</Toolbar>
	</AppBarRoot>
);

export default StickyAppBar;
